
import { mapActions, mapGetters } from "vuex";
export default {
	data() {
        return{
            show_pop_up: false
        };
	},
	async mounted() {
        setTimeout(() => {

            this.show_pop_up = true;
        }, 600);
	},
	computed: {
		...mapGetters({
			getterLogin: 'getterLogin',
            getterBasicData: 'getterBasicData',
		}),
        getShowPopUp(){
            return this.show_pop_up;
        },
        getPhoneCall(){
            return this.getterBasicData?.contact_information.phones.find( (item) => item.call );
        }
	},
    methods: {
        ...mapActions({
            saveCallLead: 'saveCallLead'
        })
    }
}
